export default __webpack_public_path__ + "static/media/5_int_Osmos_Tortora-120x120_Est_Matt_Tortora_120x120_c2grip.999fd79e.jpg";